import { render } from "./InDel_Details.vue?vue&type=template&id=bd46fd82"
import script from "./InDel_Details.vue?vue&type=script&lang=js"
export * from "./InDel_Details.vue?vue&type=script&lang=js"

import "./InDel_Details.vue?vue&type=style&index=0&id=bd46fd82&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__